<template>
  <div class="header">
    <h1>🤖 AI Model Comparison Tool</h1>
    <p>Test different AI models and compare their responses, costs, and performance</p>
  </div>
</template>

<script>
export default {
  name: 'Header'
}
</script>

<style scoped>
.header {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  color: white;
  padding: 30px;
  text-align: center;
  border-radius: 20px 20px 0 0;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
  margin: 20px 20px 0 20px;
}

.header h1 {
  font-size: 2.5em;
  margin-bottom: 10px;
  font-weight: 300;
}

.header p {
  opacity: 0.9;
  font-size: 1.1em;
}

@media (max-width: 768px) {
  .header {
    padding: 20px;
    margin: 10px 10px 0 10px;
  }
  
  .header h1 {
    font-size: 2em;
  }
}
</style>